export default class CreditsState extends Phaser.State {
  create () {
    this.add.bitmapText(16, 16, 'monospace', 'CREDITS', 9)

    this.menuItems = [
      this.add.bitmapText(16, 50, 'monospace', 'JOSEPH MANSFIELD', 9),
      this.add.bitmapText(16, 62, 'monospace', 'CHRIS CONNELLY', 9),
      this.add.bitmapText(16, 74, 'monospace', 'KIERAN DOONAN', 9),
      this.add.bitmapText(16, 86, 'monospace', 'BOB BROWNHILL', 9)
    ]

    const onEnter = () => {
      this.state.start('init', true, false, 0)
    }

    const enterKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ENTER)
    enterKey.onDown.add(() => { onEnter() })
    const mKey = this.game.input.keyboard.addKey(Phaser.Keyboard.M)
    mKey.onDown.add(() => { onEnter() })
    const escapeKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ESC)
    escapeKey.onDown.add(() => { onEnter() })
  }
}
